import React from 'react';
import AbstractComponent from '../AbstractComponent';
import ContentMini from '../layout/content/ContentMini';
import SenhaContent from './SenhaContent';

class Senha extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            preload: false,
            erro: '',
            sucesso: ''
        }
    }

    componentDidMount() {
        this.onTitulo("Alterar Senha");

        if(!this.isLogged())
            return this.login2();
    }

    render() {
        return (
            <ContentMini
                preload={this.state.preload}
                modalErro={this.state.erro}
                modalSucesso={this.state.sucesso}

                onCloseAlerta={() => this.setState({ erro: '' })}
                onCloseSucesso={() => { this.setState({ sucesso: '' }); this.homePage2() }}

                component={(props) => {
                    return <SenhaContent
                        {...props}

                        route={(item) => this.props.route(item)}
                        preload={this.state.preload}

                        showPreload={(value) => this.setState({ preload: value })}
                        showErro={(value) => this.setState({ erro: value })}
                        showSucesso={(value) => this.setState({ sucesso: value })}
                    />
                }}
            />
        )
    }
}

export default Senha;